var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as moment from 'moment-timezone';
import * as _ from 'lodash';
import getUser from './user';
export var strToFloat = function (a) { return a ? parseFloat(a.toString().replace(',', '').replace(' ', '')) : null; }; // Safe conversion from str to float
export function whereQuery(filterOptions) {
    var _a;
    var options = _.cloneDeep(filterOptions);
    var where = {
        _and: []
    };
    var date = {
        _and: []
    };
    if (!options) {
        return where;
    }
    switch (options.selectedTimeframe) {
        case 'Today':
            date._and.push({
                date: {
                    _gte: moment().tz('America/Denver').startOf('day').toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: moment().tz('America/Denver').endOf('day').toISOString()
                }
            });
            break;
        case 'Yesterday':
            var yesterday = moment().tz('America/Denver').subtract(1, 'days').startOf('day');
            date._and.push({
                date: {
                    _gte: yesterday.toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: yesterday.clone().endOf('day').toISOString()
                }
            });
            break;
        case 'This Week':
            date._and.push({
                date: {
                    _gte: moment().tz('America/Denver').startOf('week').toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: moment().tz('America/Denver').endOf('week').toISOString()
                }
            });
            break;
        case 'Last Week':
            var lastWeek = moment().tz('America/Denver').subtract(1, 'weeks').startOf('week');
            date._and.push({
                date: {
                    _gte: lastWeek.toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: lastWeek.clone().endOf('week').toISOString()
                }
            });
            break;
        case 'This Month':
            date._and.push({
                date: {
                    _gte: moment().tz('America/Denver').startOf('month').toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: moment().tz('America/Denver').endOf('month').toISOString()
                }
            });
            break;
        case 'Last Month':
            var lastMonth = moment().tz('America/Denver').subtract(1, 'months').startOf('month');
            date._and.push({
                date: {
                    _gte: lastMonth.toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: lastMonth.clone().endOf('month').toISOString()
                }
            });
            break;
        case 'This Quarter':
            date._and.push({
                date: {
                    _gte: moment().tz('America/Denver').startOf('quarter').toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: moment().tz('America/Denver').endOf('quarter').toISOString()
                }
            });
            break;
        case 'Last Quarter':
            var lastQuarter = moment().tz('America/Denver').subtract(1, 'quarter').startOf('quarter');
            date._and.push({
                date: {
                    _gte: lastQuarter.toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: lastQuarter.clone().endOf('quarter').toISOString()
                }
            });
            break;
        case 'This Year':
            date._and.push({
                date: {
                    _gte: moment().tz('America/Denver').startOf('year').toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: moment().tz('America/Denver').endOf('year').toISOString()
                }
            });
            break;
        case 'Last Year':
            var lastYear = moment().tz('America/Denver').subtract(1, 'year').startOf('year');
            date._and.push({
                date: {
                    _gte: lastYear.toISOString()
                }
            });
            date._and.push({
                date: {
                    _lt: lastYear.clone().endOf('year').toISOString()
                }
            });
            break;
        case 'All Time':
            break;
        default:
            date._and.push({
                date: {
                    _gte: moment().tz('America/Denver').startOf('day').toISOString()
                }
            });
            break;
    }
    if (options.showTimeframe) {
        where._and.push(date);
    }
    if (options.selectedSilo && options.selectedSilo.name && (options.showSilo || options.getAlways)) {
        where._and.push({
            weights: {
                silo: {
                    _eq: options.selectedSilo.name
                }
            }
        });
    }
    else if (options.selectedSilo && _.isArray(options.selectedSilo) && options.selectedSilo.length > 0 && options.showSilo) {
        var orOp_1 = [];
        _.forEach(options.selectedSilo, function (silo) {
            if (!options.notBolSilos) {
                orOp_1.push({
                    weights: {
                        silo: {
                            _eq: silo.name
                        }
                    }
                });
            }
            else {
                orOp_1.push({
                    name: {
                        _eq: silo.name
                    }
                });
            }
            where._and.push({
                _or: orOp_1
            });
        });
    }
    if (options.selectedProduct && options.selectedProduct.name && options.showProduct) {
        where._and.push({
            product: {
                _eq: options.selectedProduct.name
            }
        });
    }
    else if (options.selectedProduct && _.isArray(options.selectedProduct) && options.selectedProduct.length > 0 && options.showProduct) {
        var orOp_2 = [];
        _.forEach(options.selectedProduct, function (product) {
            orOp_2.push({
                product: {
                    _eq: product.name
                }
            });
            where._and.push({
                _or: orOp_2
            });
        });
    }
    if (options.selectedLocation && options.selectedLocation.name && options.showLocation) {
        where._and.push({
            location: {
                _eq: options.selectedLocation.name
            }
        });
    }
    else if (options.selectedLocation && _.isArray(options.selectedLocation) && options.selectedLocation.length > 0 && options.showLocation) {
        var orOp_3 = [];
        _.forEach(options.selectedLocation, function (location) {
            orOp_3.push({
                location: {
                    _eq: location.name
                }
            });
            where._and.push({
                _or: orOp_3
            });
        });
    }
    if (options.searchQuery && options.searchQuery.length && options.showSearch) {
        var searchColumn = '';
        switch (options.selectedQuery) {
            case 'BOL #':
                searchColumn = 'bill_of_lading';
                break;
            case 'Pick Up #':
                searchColumn = 'pick_up_num';
                break;
            case 'Invoice #':
                searchColumn = 'invoice_num';
                break;
            case 'Equipment ID':
                searchColumn = 'truck_num';
                break;
            default:
                searchColumn = 'po_num';
                break;
        }
        where._and.push((_a = {},
            _a[searchColumn] = {
                _ilike: "%" + options.searchQuery + "%"
            },
            _a));
    }
    if (options.inboundOutbound) {
        if (options.inboundOutbound === 'inbound') {
            where._and.push({
                weights: { net_weight: { _gt: "0" } }
            });
        }
        else if (options.inboundOutbound === 'outbound') {
            where._and.push({
                weights: { net_weight: { _lt: "0" } }
            });
        }
    }
    if (options.company && options.company.name) {
        where._and.push({
            company: { _eq: options.company.name }
        });
    }
    if (options.customer && options.customer.name) {
        where._and.push({
            customer: { _eq: options.customer.name }
        });
    }
    return where;
}
export function verifyBolForm(bolObj) {
    if (!bolObj.date || !moment(bolObj.date).isValid()) {
        console.log('invalid date');
        return false;
    }
    if (!bolObj.pick_up_num || isNaN(bolObj.pick_up_num) || bolObj.pick_up_num < 0 ||
        !bolObj.desired_weight || isNaN(bolObj.desired_weight) || bolObj.desired_weight < 0 ||
        !bolObj.tare_weight || isNaN(bolObj.tare_weight) || bolObj.tare_weight < 0) {
        console.log('invalid number');
        return false;
    }
    if (!bolObj.po_num || !bolObj.po_num.length ||
        !bolObj.customer || !bolObj.customer.length ||
        !bolObj.location || !bolObj.location.length ||
        !bolObj.truck_num || !bolObj.truck_num.length ||
        !bolObj.product || !bolObj.product.length ||
        !bolObj.driver_name || !bolObj.driver_name.length ||
        !bolObj.loading_operator || !bolObj.loading_operator.length ||
        !bolObj.carrier || !bolObj.carrier.length) {
        console.log('invalid string data');
        return false;
    }
    if (bolObj.weights && bolObj.weights.length) {
        var uniqSilos = _.uniqBy(bolObj.weights, 'silo');
        if (uniqSilos.length !== bolObj.weights.length) {
            return false;
        }
        var checker_1 = true;
        _.forEach(bolObj.weights, function (silo) {
            if (!silo.silo || !silo.silo.length) {
                checker_1 = false;
            }
            if (!silo.net_weight || isNaN(silo.net_weight)) {
                checker_1 = false;
            }
        });
        if (!checker_1) {
            console.log('invalid silo data');
            return false;
        }
    }
    return true;
}
export function fixBolDate(bolObj, isUpdating) {
    return __awaiter(this, void 0, void 0, function () {
        var fixedObj, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fixedObj = _.cloneDeep(bolObj);
                    fixedObj.date = moment(fixedObj.date).toISOString();
                    return [4 /*yield*/, getUser()];
                case 1:
                    user = _a.sent();
                    if (isUpdating) {
                        fixedObj.updated_at = moment().toISOString();
                        fixedObj.updated_by = user.email;
                    }
                    else {
                        fixedObj.created_at = moment().toISOString();
                        fixedObj.created_by = user.email;
                    }
                    return [2 /*return*/, fixedObj];
            }
        });
    });
}
export function cleanBol(bolObj) {
    var allowedKeys = [
        'bill_of_lading',
        'carrier',
        'customer',
        'date',
        'desired_weight',
        'driver_name',
        'halliburton_location',
        'halliburton_po',
        'halliburton_ticket',
        'halliburton_tms',
        'halliburton_trans_id',
        'invoice_num',
        'loading_operator',
        'location',
        'pick_up_num',
        'po_num',
        'product',
        'tare_weight',
        'truck_num',
    ];
    var cleanBol = {};
    _.forOwn(bolObj, function (val, key) {
        if (_.includes(allowedKeys, key)) {
            cleanBol[key] = val;
        }
    });
    return cleanBol;
}
export function transformForCreate(cleanBol, saveBol) {
    var clonedBol = _.cloneDeep(cleanBol);
    clonedBol.updates = {
        data: [
            {
                type: 'Created',
                when: saveBol.created_at,
                email: saveBol.created_by
            }
        ]
    };
    clonedBol.weights = {
        data: []
    };
    _.forEach(saveBol.weights, function (weight) {
        clonedBol.weights.data.push({
            net_weight: weight.net_weight,
            silo: weight.silo
        });
    });
    return clonedBol;
}
export function setBolDate(bolObj) {
    var setObj = _.cloneDeep(bolObj);
    setObj.date = moment(setObj.date).toDate();
    return setObj;
}
export function addSilo(bolObj) {
    if (!bolObj.weights) {
        bolObj.weights = [];
    }
    bolObj.weights.push({ silo: null });
}
export function removeSilo(bolObj, index) {
    bolObj.weights.splice(index, 1);
}



//////////////////
// WEBPACK FOOTER
// ./src/services/sharedForm.ts
// module id = 48
// module chunks = 1